var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "management-section-wrapper" },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "management-section-title" }, [
                _vm._v(_vm._s(_vm.$tc("License")))
              ]),
              _vm._v(" "),
              _c("v-spacer")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tabs",
            {
              staticClass: "user-tab-container pl-0",
              attrs: { "align-with-title": "" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            [
              _c("v-tabs-slider", { attrs: { color: "accent" } }),
              _vm._v(" "),
              _vm._l(_vm.items, function(item) {
                return _c(
                  "v-tab",
                  {
                    key: item,
                    class: {
                      "user-tab-active": _vm.tab === _vm.items.indexOf(item)
                    }
                  },
                  [_vm._v("\n        " + _vm._s(item) + "\n      ")]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            _vm._l(_vm.items, function(item) {
              return _c(
                "v-tab-item",
                { key: item },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c("VueShowdown", {
                        staticStyle: {
                          "text-align": "justify",
                          padding: "0 20px 20px 20px"
                        },
                        attrs: { markdown: _vm.getLicense(item) }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6f9cdce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6f9cdce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Licenses/LicensesList.vue
// module id = null
// module chunks = 